import React, {FormEvent, forwardRef, MutableRefObject, type TextareaHTMLAttributes, useEffect, useRef} from "react";
import cn from "classnames";

import * as styles from "./Textarea.module.css";

export interface IProps extends Partial<TextareaHTMLAttributes<HTMLTextAreaElement>> {
    error?: boolean;
    expandable?: {min: number; max: number};
}

export const Textarea = forwardRef<HTMLTextAreaElement, IProps>((props, ref) => {
    const {className, error, expandable, value, defaultValue, ...textareaProps} = props;
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    const setRef = (instance: HTMLTextAreaElement | null) => {
        textareaRef.current = instance;
        if (ref && "current" in ref) {
            (ref as MutableRefObject<HTMLTextAreaElement | null>).current = instance;
        } else if (typeof ref === "function") {
            ref(instance);
        }
    };

    const adjustHeight = () => {
        if (expandable && textareaRef.current) {
            textareaRef.current.style.height = "auto";
            const maxHeight = expandable.max * parseInt(getComputedStyle(textareaRef.current).lineHeight);
            const height = Math.min(textareaRef.current.scrollHeight, maxHeight);
            textareaRef.current.style.height = height + "px";
        }
    };

    useEffect(() => {
        adjustHeight();
    }, [expandable, defaultValue]);

    const handleInput = (e: FormEvent<HTMLTextAreaElement>) => {
        adjustHeight();
        if (textareaProps.onInput) {
            textareaProps.onInput(e);
        }
    };
    return (
        <div className={cn(className, styles.textareaContainer, error && styles.textareaContainerError)}>
            <textarea
                className={styles.textarea}
                ref={setRef}
                rows={expandable?.min ?? 5}
                value={value === null ? "" : value}
                defaultValue={value === undefined ? defaultValue : ""}
                {...textareaProps}
                onInput={expandable ? handleInput : textareaProps.onInput}
            />
        </div>
    );
});
import React, {FormEvent, forwardRef, MutableRefObject, type TextareaHTMLAttributes, useEffect, useRef} from "react";
import cn from "classnames";

import * as styles from "./Textarea.module.css";

export interface IProps extends Partial<TextareaHTMLAttributes<HTMLTextAreaElement>> {
    error?: boolean;
    expandable?: {min: number; max: number};
}

export const Textarea = forwardRef<HTMLTextAreaElement, IProps>((props, ref) => {
    const {className, error, expandable, value, defaultValue, ...textareaProps} = props;
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    const setRef = (instance: HTMLTextAreaElement | null) => {
        textareaRef.current = instance;
        if (ref && "current" in ref) {
            (ref as MutableRefObject<HTMLTextAreaElement | null>).current = instance;
        } else if (typeof ref === "function") {
            ref(instance);
        }
    };

    const adjustHeight = () => {
        if (expandable && textareaRef.current) {
            textareaRef.current.style.height = "auto";
            const maxHeight = expandable.max * parseInt(getComputedStyle(textareaRef.current).lineHeight);
            const height = Math.min(textareaRef.current.scrollHeight, maxHeight);
            textareaRef.current.style.height = height + "px";
        }
    };

    useEffect(() => {
        adjustHeight();
    }, [expandable, defaultValue]);

    const handleInput = (e: FormEvent<HTMLTextAreaElement>) => {
        adjustHeight();
        if (textareaProps.onInput) {
            textareaProps.onInput(e);
        }
    };
    return (
        <div className={cn(className, styles.textareaContainer, error && styles.textareaContainerError)}>
            <textarea
                className={styles.textarea}
                ref={setRef}
                rows={expandable?.min ?? 5}
                value={value === null ? "" : value}
                defaultValue={value === undefined ? defaultValue : ""}
                {...textareaProps}
                onInput={expandable ? handleInput : textareaProps.onInput}
            />
        </div>
    );
});
